import React from 'react';
import { Link } from 'react-router-dom';
import "./payment.css";


const Success = (props) => {
    return (
        <div className="pricingPlan"
        style={{
          background: "url(/images/home/show-1.jpg) no-repeat scroll 0 0",
        }}>
         <div className='main-content'>
             <section className='pricing'>
             <div className="container py-5">
          {/*Title */}
          <div className="row mb-4">
            <div className="col-lg-8 mx-auto text-center">
          
            </div>
          </div>{" "}
       
          {/*Payment Form*/}
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="card ">
                <div className="card-header">
                  <div className="shadow-sm pt-4 pl-2 pr-2 pb-2">
                    {/* Credit card form tabs */}
                    <div className="row">
                        <div className="col-md-12">
                          <h6 className="card-price text-center card-plan">
                          <i className="fa fa-check-circle-o greener"></i> Payment Successfull
                          </h6>
                          <hr />
                          
                           <ul className="fa-ul">
                            <li><b>{"Your Membership is now active"}</b></li>
                            <li>{props.plan.access_type.name==="subscription"?"You will charged "+ props.plan.amount+" "+props.plan.currency +" per "+props.plan.access_type.period:props.plan.access_type.name==="ppv"?props.plan.access_type.quantity+" "+props.plan.access_type.period+" access":"One time Payment"}</li>
                            {props.plan.access_type.name==="subscription"?<li>You can cancel the active subscription anytime</li>:""}
                            {props.plan.access_type.name==="subscription"?<li>We will be sending </li>:""}
                            <li>American Tv Shows</li>
                            <li>Hollywood Movies</li>
                            <li>FHD (1080p) Video Quality</li>
                            <li>Ad Free Entertainment</li>
                          </ul>         
                        </div>
                       
                      </div>
                  </div>
                  {/* End */}
                  {/* Credit card form content */}
                   <div className="row">
                       <div className='col-md-12'>
                        <Link  className="subscribe btn btn-primary btn-block shadow-sm" to={props.redirect?props.redirect.type==="video"?"/" + props.match.params.AppId + "/videopage/"+props.redirect.redirect:"/" + props.match.params.AppId + "/home":"/" + props.match.params.AppId + "/home"}>Start Watching</Link>
                       </div>
                   </div>
                </div>
              </div>
            </div>
          </div>
          {/*End */}
        </div>

             </section>

         </div>
        </div>
      
      );
};

export default Success;